import styled, { createGlobalStyle } from 'styled-components'

const EstiloGlobal = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Inter", sans-serif;
    list-style: none;
  }

  body {
    padding-top: 80px;
    padding-bottom: 80px;
    background-color: ${(props) => props.theme.corDeFundo};

    @media (max-width: 768px) {
      padding-top: 16px;
      padding-bottom: 16px;
    }
  }
`

export default EstiloGlobal

export const Container = styled.div`
  max-width: 1024px;
  width: 100%;
  margin: 0 auto;

  display: grid;
  grid-template-columns: 128px 1fr;
  column-gap: 56px;

  main {
    width: 100%;
  }

 @media (max-width: 768px) {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 32px;

  aside {
    width: 100%;
  }
`
